import * as Yup from 'yup';

// /**
//  * Creates a validation schema for the job definition form
//  * @returns {Object} - Yup validation schema
//  */
// export const createValidationSchema = () => {
//   return Yup.object({
//     name: Yup.string().required('Name is required'),
//     dataSource: Yup.string().required('Data source is required'),
//     sourceEndpoint: Yup.string().required('Source endpoint is required'),
    
//     // Data Time Configuration
//     dataTimeConfig: Yup.object({
//       mode: Yup.string().required('Time range mode is required'),
      
//       // Conditional validation for RELATIVE mode
//       relativeValue: Yup.number().when('mode', {
//         is: 'RELATIVE',
//         then: Yup.number()
//           .required('Value is required')
//           .positive('Must be positive')
//       }),
//       relativeUnit: Yup.string().when('mode', {
//         is: 'RELATIVE',
//         then: Yup.string().required('Unit is required')
//       }),
      
//       // Conditional validation for ABSOLUTE mode
//       startDateTime: Yup.date().when('mode', {
//         is: 'ABSOLUTE',
//         then: Yup.date().required('Start date is required')
//       }),
//       endDateTime: Yup.date().when('mode', {
//         is: 'ABSOLUTE',
//         then: Yup.date()
//           .required('End date is required')
//           .min(
//             Yup.ref('startDateTime'),
//             'End date must be after start date'
//           )
//       })
//     }),
    
//     // Schedule Configuration
//     scheduleConfig: Yup.object({
//       mode: Yup.string().required('Schedule mode is required'),
      
//       // Conditional validation for RECURRING mode
//       cronExpression: Yup.string().when('mode', {
//         is: 'RECURRING',
//         then: Yup.string().required('Cron expression is required')
//       }),
      
//       // Conditional validation for ONE_TIME mode
//       scheduledTime: Yup.date().when('mode', {
//         is: 'ONE_TIME',
//         then: Yup.date().required('Scheduled time is required')
//       }),
      
//       // Time zone validation
//       timeZoneStrategy: Yup.string().required('Time zone strategy is required'),
//       specificTimeZone: Yup.string().when('timeZoneStrategy', {
//         is: 'SPECIFIC',
//         then: Yup.string().required('Specific time zone is required')
//       }),
      
//       // Schedule window validation (optional)
//       scheduleEndDate: Yup.date().when('scheduleStartDate', {
//         is: (startDate) => startDate !== null && startDate !== undefined,
//         then: Yup.date().min(
//           Yup.ref('scheduleStartDate'),
//           'End date must be after start date'
//         )
//       })
//     }),
    
//     status: Yup.string().required('Status is required'),
    
//     // Optional settings validation
//     settings: Yup.mixed().test(
//       'is-valid-json',
//       'Settings must be valid JSON',
//       function(value) {
//         if (!value) return true;
        
//         if (typeof value === 'object') return true;
        
//         if (typeof value === 'string') {
//           try {
//             JSON.parse(value);
//             return true;
//           } catch (e) {
//             return false;
//           }
//         }
        
//         return false;
//       }
//     )
//   });
// };

// In JobFormValidation.js
export const createValidationSchema = () => {
  return Yup.object().shape({
    // Basic info
    name: Yup.string().required('Job name is required'),
    description: Yup.string().nullable(),
    
    // Source configuration
    dataSource: Yup.string().required('Data source is required'),
    sourceEndpoint: Yup.string().required('Source endpoint is required'),
    sourceFilters: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required(),
        values: Yup.array().of(Yup.string()).required()
      })
    ),
    
    // Data Time Configuration
    dataTimeConfig: Yup.object().shape({
      mode: Yup.string().required('Time range mode is required'),
      relativeValue: Yup.number().nullable().when('mode', {
        is: 'RELATIVE',
        then: Yup.number().required('Value is required for relative mode')
      }),
      relativeUnit: Yup.string().nullable().when('mode', {
        is: 'RELATIVE',
        then: Yup.string().required('Unit is required for relative mode')
      }),
      startDateTime: Yup.date().nullable().when('mode', {
        is: 'ABSOLUTE',
        then: Yup.date().required('Start date is required for absolute mode')
      }),
      endDateTime: Yup.date().nullable().when('mode', {
        is: 'ABSOLUTE',
        then: Yup.date().required('End date is required for absolute mode')
      }),
      granularity: Yup.string().nullable()
    }),
    
    // Schedule Configuration
    scheduleConfig: Yup.object().shape({
      mode: Yup.string().required('Schedule mode is required'),
      cronExpression: Yup.string().nullable().when('mode', {
        is: 'RECURRING',
        then: Yup.string().required('Cron expression is required for recurring mode')
      }),
      timeZoneStrategy: Yup.string().required('Time zone strategy is required'),
      specificTimeZone: Yup.string().nullable().when('timeZoneStrategy', {
        is: 'SPECIFIC',
        then: Yup.string().required('Time zone is required for specific time zone strategy')
      }),
      scheduledTime: Yup.date().nullable().when('mode', {
        is: 'ONE_TIME',
        then: Yup.date().required('Scheduled time is required for one-time mode')
      }),
      scheduleStartDate: Yup.date().nullable(),
      scheduleEndDate: Yup.date().nullable()
    })
  });
};